import {
  Box,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Button,
  Alert,
} from '@mui/material';
import BoltIcon from '@mui/icons-material/Bolt';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useNavigate } from 'react-router-dom';

const TokenInfoPanel = ({ plan, isTrailEnabled }: { plan: boolean; isTrailEnabled: boolean }) => {
  const navigate = useNavigate();

  return (
    <Paper elevation={0} sx={{ py: 1 }}>
      <List dense disablePadding>
        <ListItem disableGutters>
          <ListItemIcon>
            <BoltIcon sx={{ color: '#9685FF' }} />
          </ListItemIcon>
          <ListItemText primary="100 Credits included in your monthly plan." />
        </ListItem>

        <ListItem disableGutters>
          <ListItemIcon>
            <ChatBubbleOutlineIcon sx={{ color: 'text.secondary' }} />
          </ListItemIcon>
          {plan ? (
            <ListItemText primary="1 Credit ≈ 1 Chats (~60K tokens)" />
          ) : (
            <ListItemText primary="2 Credit ≈ 1 Chats (~60K tokens)" />
          )}
        </ListItem>

        {plan && (
          <>
            <ListItem disableGutters>
              <ListItemIcon>
                <SmsOutlinedIcon sx={{ color: 'text.secondary' }} />
              </ListItemIcon>
              <ListItemText primary="1 Credit ≈ 3 SMS" />
            </ListItem>

            <ListItem disableGutters>
              <ListItemIcon>
                <EmailOutlinedIcon sx={{ color: 'text.secondary' }} />
              </ListItemIcon>
              <ListItemText primary="1 Credit ≈ 350 Emails" />
            </ListItem>
          </>
        )}
      </List>

      <Box mt={3}>
        {isTrailEnabled ? (
          <Alert severity="info" sx={{ fontSize: 13 }}>
            You’re on a free trial—100 credits reset every 30 days. Subscribe to a paid plan to add
            more credits anytime.
          </Alert>
        ) : (
          <Box textAlign="right">
            <Button
              variant="contained"
              endIcon={<ArrowForwardIcon />}
              onClick={() => navigate('/dashboard/subscriptions')}
            >
              Add More Credits
            </Button>
          </Box>
        )}
      </Box>
    </Paper>
  );
};

export default TokenInfoPanel;
